import { PERMISSION_BUNDLE_REGISTRY, resolvePermissionBundle, } from './permission-bundle.registry.js';
export { ENTITLEMENT_EXEMPT_MODULES } from './entitlements.js';
export const CANONICAL_PERSONAS = [
    'PLATFORM_ROOT',
    'PLATFORM_ADMIN',
    'PLATFORM_USER',
    'ORG_ADMIN',
    'ORG_USER',
    'ORG_CLIENT',
];
export const PLATFORM_PERSONAS = [
    'PLATFORM_ROOT',
    'PLATFORM_ADMIN',
    'PLATFORM_USER',
];
export const ORG_PERSONAS = [
    'ORG_ADMIN',
    'ORG_USER',
    'ORG_CLIENT',
];
export function personasForOrgCode(code) {
    return code === 'PLATFORM' ? PLATFORM_PERSONAS : ORG_PERSONAS;
}
export const MODULE_KEYS = [
    'PLATFORM',
    'AUTH',
    'DASHBOARD',
    'SETTINGS',
    'NAVIGATION',
    'INVESTMENT',
    'ACCOUNTING',
    'TAX',
    'RECONCILIATION',
    'CORPORATE_ACTIONS',
    'REPORTING',
    'IMPORT',
    'INSTRUMENTS',
    'FACTS',
    'HOLDINGS',
    'MARGIN_TRADING',
    'ORDER_MANAGEMENT',
    'MARKET_DATA',
    'DATA',
    'ADMIN',
    'REGULATORY',
];
export function isModuleKey(value) {
    return MODULE_KEYS.includes(value);
}
export function isPlatformPrincipal(p) {
    return p.scopeKind === 'SYSTEM' || p.scopeKind === 'PLATFORM';
}
export function isOrganizationPrincipal(p) {
    return p.scopeKind === 'ORGANIZATION' || p.scopeKind === 'BRANCH';
}
export function isClientPrincipal(p) {
    return p.scopeKind === 'CLIENT' || p.scopeKind === 'PORTFOLIO';
}
export const PERSONA_SCOPE_MAP = {
    PLATFORM_ROOT: 'SYSTEM',
    PLATFORM_ADMIN: 'PLATFORM',
    PLATFORM_USER: 'PLATFORM',
    ORG_ADMIN: 'ORGANIZATION',
    ORG_USER: 'ORGANIZATION',
    ORG_CLIENT: 'CLIENT',
};
export const PERSONA_ACTOR_TYPE_MAP = {
    PLATFORM_ROOT: 'USER',
    PLATFORM_ADMIN: 'USER',
    PLATFORM_USER: 'USER',
    ORG_ADMIN: 'USER',
    ORG_USER: 'USER',
    ORG_CLIENT: 'CLIENT',
};
export const PERSONA_DEFAULT_AAL = {
    PLATFORM_ROOT: 'AAL2',
    PLATFORM_ADMIN: 'AAL2',
    PLATFORM_USER: 'AAL1',
    ORG_ADMIN: 'AAL2',
    ORG_USER: 'AAL1',
    ORG_CLIENT: 'AAL1',
};
export const PERSONA_DEFAULT_BUNDLES = {
    PLATFORM_ROOT: ['platform.root'],
    PLATFORM_ADMIN: ['platform.admin'],
    PLATFORM_USER: ['platform.user'],
    ORG_ADMIN: ['organization.admin'],
    ORG_USER: ['organization.user.base', 'organization.user.reports-reader'],
    ORG_CLIENT: ['organization.client.base'],
};
export const PERSONA_LABELS = {
    PLATFORM_ROOT: 'Platform Root',
    PLATFORM_ADMIN: 'Platform Admin',
    PLATFORM_USER: 'Platform User',
    ORG_ADMIN: 'Org Admin',
    ORG_USER: 'Org User',
    ORG_CLIENT: 'Org Client',
};
export function isCanonicalPersona(persona) {
    return CANONICAL_PERSONAS.includes(persona);
}
export function getPersonaScope(persona) {
    return PERSONA_SCOPE_MAP[persona];
}
export function getPersonaActorType(persona) {
    return PERSONA_ACTOR_TYPE_MAP[persona];
}
export function getPersonaDefaultAal(persona) {
    return PERSONA_DEFAULT_AAL[persona];
}
export function getPersonaDefaultBundles(persona) {
    return PERSONA_DEFAULT_BUNDLES[persona];
}
export function resolvePersonaPermissions(persona) {
    const bundleIds = PERSONA_DEFAULT_BUNDLES[persona];
    if (!bundleIds?.length)
        return [];
    const permissions = new Set();
    for (const bundleId of bundleIds) {
        for (const permission of resolvePermissionBundle(bundleId).permissionIds)
            permissions.add(permission);
    }
    return Array.from(permissions);
}
export function validatePlatformBundleNoBranchBusinessPermissions(bundleId) {
    const bundle = resolvePermissionBundle(bundleId);
    if (!['PLATFORM_ROOT', 'PLATFORM_ADMIN', 'PLATFORM_USER'].includes(bundle.persona))
        return;
    const branchBusinessPrefixes = [
        'transactions:',
        'instruments:',
        'import:',
        'reconciliation:',
        'corporateActions:',
        'facts:',
        'reports:',
        'holdings:',
        'data:',
    ];
    for (const permission of bundle.permissionIds) {
        for (const prefix of branchBusinessPrefixes) {
            if (permission.startsWith(prefix)) {
                throw new Error(`PLATFORM_BUNDLE_CONTAINS_BRANCH_PERMISSION: ${bundleId} contains ${permission}`);
            }
        }
    }
}
export function validateClientBundleNoWritePermissions(bundleId) {
    const bundle = resolvePermissionBundle(bundleId);
    if (bundle.persona !== 'ORG_CLIENT')
        return;
    const writePrefixes = ['create', 'manage', 'update', 'delete', 'approve', 'reverse', 'commit'];
    for (const permission of bundle.permissionIds) {
        for (const prefix of writePrefixes) {
            if (permission.includes(`:${prefix}`) || permission.endsWith(`:${prefix}`)) {
                throw new Error(`CLIENT_BUNDLE_CONTAINS_WRITE_PERMISSION: ${bundleId} contains ${permission}`);
            }
        }
    }
}
export function validateAllPermissionBundles() {
    for (const bundleId of Object.keys(PERMISSION_BUNDLE_REGISTRY)) {
        validatePlatformBundleNoBranchBusinessPermissions(bundleId);
        validateClientBundleNoWritePermissions(bundleId);
    }
}
validateAllPermissionBundles();
